import BaseComponent from '../../components/base-component/base-component'
import { Nullable } from '../../types/common'
import ProductForm from './product-form'

class ProductFormButton extends BaseComponent {
  button: Nullable<HTMLElement>
  footer: Nullable<HTMLElement>
  form: Nullable<ProductForm>

  constructor() {
    super()

    this.button = this.querySelector('[data-product-form-button]')
    this.footer = document.querySelector<HTMLElement>(
      '.shopify-section.shopify-section-footer',
    )
    this.form = this.closest('product-form')
  }

  connectedCallback(): void {
    window.addEventListener('scroll', this.handleWindowScroll)
  }

  disconnectedCallback(): void {
    window.removeEventListener('scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    if (!this.button || !this.form) {
      return
    }

    const scrollPosition = window.scrollY
    const criticalPoint = this.form.offsetTop + this.form.offsetHeight

    const footerOffsetTop = this.footer ? this.footer.offsetTop : 0
    const isOverFooter = window.innerHeight + scrollPosition < footerOffsetTop

    const isVisible = isOverFooter && scrollPosition > criticalPoint

    this.toggleAttribute('visible', isVisible)

    document.body.toggleAttribute('is-product-form-button-fixed', isVisible)
  }
}

export default ProductFormButton
